import styled from 'styled-components';

export const CalendarExportSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const CalendarExportFieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;

  .form-group {
    margin-bottom: 0;
  }
`;

export const CheckboxsContainer = styled.div`
  display: flex;
  gap: 18px;

  .checkbox {
    padding-top: 0;
  }
`;
